import { Box, Paper, useTheme } from '@mui/material';
import { Panel, Group, Separator } from 'react-resizable-panels';
import DefectsList from './DefectsList';
import { FC } from 'react';
import DefectCard from './DefectCard';

interface DefectsContainerProps {}

const DefectsContainer: FC<DefectsContainerProps> = () => {
    const theme = useTheme();

    return (
        <Paper variant="outlined" sx={{ p: 2, height: '100%', minWidth: 880 }}>
            <Group orientation="horizontal" style={{ display: 'flex', gap: '16px', height: '100%' }}>
                <Panel defaultSize={'50%'} minSize={460}>
                    <DefectsList />
                </Panel>
                <Separator
                    style={{
                        width: 33,
                        cursor: 'col-resize',
                        display: 'flex',
                        alignItems: 'stretch',
                        justifyContent: 'center',
                        outline: 'none',
                        boxShadow: 'none',
                    }}
                >
                    <Box
                        sx={{
                            width: '1px',
                            background: theme.palette.divider,
                        }}
                    />
                </Separator>
                <Panel minSize={440} style={{ overflowY: 'auto' }}>
                    <DefectCard />
                </Panel>
            </Group>
        </Paper>
    );
};

export default DefectsContainer;
